var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-content',[_c('app-sub-title',{attrs:{"text":"Indicadores de Operación"}}),_vm._v(" "),(!!_vm.client)?_c('app-dashboard-report',{attrs:{"selected-client":_vm.client}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }